export default __webpack_public_path__ + "static/media/bottle.b19cd57e.jpg";